<template>
  <div
    v-if="visivel && !sidebar"
    ref="containerRef"
    v-click-outside="fecharOverlay"
    class="lg-aa-overlayPanel"
  >
    <div class="lg-aa-overlayPanel__conteudo">
      <slot />
    </div>
  </div>
  <PSidebar
    v-else
    v-model:visible="visivel"
    :base-z-index="999"
    :aria-close-label="$t_v2('43985', 'Fechar')"
    position="right"
    :class="[
      'lg-aa-sidebar',
      {
        'lg-aa-sidebar--medio': $lg.breakpoint.width >= 460,
        'lg-aa-sidebar--grande': $lg.breakpoint.width < 460,
      },
    ]"
  >
    <div class="lg-aa-overlayPanel__conteudo">
      <slot />
    </div>
  </PSidebar>
</template>

<script>
import DomUtils from 'lg-vue-components/services/domUtils';
import eventHandler from 'lg-vue-components/services/eventHandler';
import PSidebar from 'primevue/sidebar';

export default {
  name: 'LGOverlayPanel',
  components: {
    PSidebar,
  },
  props: {
    posicao: {
      type: String,
      default: 'esquerda',
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
    ignoreEventBus: {
      type: Boolean,
      defautl: false,
    },
  },
  data() {
    return {
      container: null,
      target: null,
      visivel: false,
      selfClick: false,
    };
  },
  computed: {
    clientWidth() {
      return this.$lg.breakpoint.width;
    },
  },
  watch: {
    clientWidth() {
      if (this.sidebar) {
        if (this.visivel) {
          this.visivel = false;
        }
      }
    },
    visivel() {
      if (!this.sidebar) {
        if (this.visivel) {
          eventHandler.emitCustomEvent(document, 'fecharMenuUsuario');

          eventHandler.removeCustomEventListener(document, 'controleOverlay', this.fecharOverlay);
          eventHandler.addCustomEventListener(document, 'controleOverlay', this.fecharOverlay);

          eventHandler.addCustomEventListener(document, 'fecharOverlay', this.fecharOverlay);
          document.addEventListener('resize', this.fecharOverlay);
          window.addEventListener('resize', this.fecharOverlay);
          DomUtils.bindScrollabeParentEvent(this.target, this.fecharOverlay);
        } else {
          eventHandler.removeCustomEventListener(document, 'fecharOverlay');
          window.removeEventListener('resize', this.fecharOverlay);
          document.removeEventListener('scroll', this.fecharOverlay);
          DomUtils.unbindScrollabeParentEvent(this.target, this.fecharOverlay);
        }
      }
    },
  },
  updated() {
    if (this.visivel && !this.sidebar) {
      this.container = this.$refs.containerRef;
      this.alinharOverlay();
    }
  },
  mounted() {
    if (this.$eventBus && !this.ignoreEventBus) {
      this.$eventBus.on('fecharOverlayPanel', this.fecharOverlay);
    }
  },
  unmounted() {
    if (this.$eventBus && !this.ignoreEventBus) {
      this.$eventBus.off('fecharOverlayPanel');
    }
  },
  methods: {
    isMobile() {
      return this.$lg.breakpoint.xsOnly;
    },
    togglePanel(target) {
      if (!this.visivel && !this.sidebar) {
        eventHandler.emitCustomEvent(document, 'controleOverlay');

        if (target.currentTarget) {
          this.target = target.currentTarget;
        } else {
          this.target = target;
        }
      }

      this.visivel = !this.visivel;
    },
    alinharOverlay() {
      const windows = DomUtils.getViewport();

      this.container.style.removeProperty('min-width');
      this.container.style.setProperty('max-width', '98%', 'important');

      if (windows.width) {
        const containerWidth = DomUtils.getWidth(this.container);
        const limite = windows.width - (windows.width * 0.05);

        if (containerWidth >= limite) {
          this.container.style.setProperty('min-width', '98%', 'important');
          this.container.style.setProperty('margin-left', 'auto', 'important');
          this.container.style.setProperty('margin-right', 'auto', 'important');
          this.container.style.setProperty('right', '0', 'important');
          this.container.style.setProperty('left', '0', 'important');
          this.container.style.setProperty('transform', 'translateX(0)', 'important');
        }
      }

      DomUtils.absolutePosition(this.container, this.target);

      if (this.posicao.toLowerCase() === 'direita') {
        this.posicionarSetaNaDireita();
      } else if (this.posicao.toLowerCase() === 'centro') {
        this.posicionarSetaNoCentro();
      } else {
        this.posicionarSetaNaEsquerda();
      }
    },
    posicionarSetaNaEsquerda() {
      const targetOffSet = DomUtils.getOffSet(this.target);
      const targetWidth = DomUtils.getWidth(this.target, false);
      const containerWidth = DomUtils.getWidth(this.container, false);

      if (!this.isMobile()) {
        this.container.style.setProperty('left', `${targetOffSet.left}px`);
      } else {
        this.container.style.setProperty('left', 'auto', 'important');
      }

      if (containerWidth > targetWidth) {
        this.container.style.setProperty('--marginArrow', `${targetWidth / 2}px`);
      } else {
        this.container.style.setProperty('--marginArrow', `${targetOffSet.left + 15}px`);
      }

      this.container.style.setProperty('--overlayArrowLeft', '0px');
    },
    posicionarSetaNaDireita() {
      const windowWidth = DomUtils.getWidth(document.getElementsByTagName('body')[0]);
      const offsetTarget = DomUtils.getOffSet(this.target);
      const targetWidth = DomUtils.getWidth(this.target, false);
      const containerWidth = DomUtils.getWidth(this.container, false);
      const rightTarget = windowWidth - (offsetTarget.left + targetWidth);

      if (!this.isMobile()) {
        this.container.style.setProperty('right', `${rightTarget}px`, 'important');
        this.container.style.setProperty('left', 'auto', 'important');
      }

      const offsetContainer = DomUtils.getOffSet(this.container);
      const rightContainer = windowWidth - (offsetContainer.left + containerWidth);

      this.container.style.setProperty('--overlayArrowLeft', `${containerWidth}px`);

      if (containerWidth > targetWidth && rightContainer === rightTarget) {
        this.container.style.setProperty('--marginArrow', `-${targetWidth / 2}px`);
      } else {
        this.container.style.setProperty('--marginArrow', `-${((rightTarget - rightContainer) + (targetWidth / 2))}px`);
      }

      if (this.container.offsetLeft < 0) {
        this.posicionarSetaNaEsquerda();
      }
    },
    posicionarSetaNoCentro() {
      const containerWidth = DomUtils.getWidth(this.container);
      const targetWidth = DomUtils.getWidth(this.target, false);
      const containerLeft = parseFloat(getComputedStyle(this.container).left);
      const targetOffSet = DomUtils.getOffSet(this.target);
      const containerCenter = containerLeft + containerWidth * 0.5;
      const targetCenter = targetOffSet.left + targetWidth * 0.5;
      const windows = DomUtils.getViewport();

      this.container.style.setProperty('--overlayArrowLeft', `${containerWidth * 0.5}px`);
      this.container.style.setProperty('--marginArrow', '0px');

      if (windows.width > 400) {
        this.container.style.setProperty('transform', `translateX(${targetCenter - containerCenter}px)`);
      }
    },
    fecharOverlay() {
      if (this.visivel) {
        this.visivel = false;
      }
    },
  },
};
</script>
